<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم درخواست کالیبراسیون</h5>


    <div>

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> شماره نامه </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">کد مشتری بهفا </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <form [formGroup]="AddNewLetter">

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> عنوان فرستنده </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">سرکار خانم</option>
              <option value="1" selected>جناب آقای</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> نام فرستنده </label>
            <input formControlName="giver_name" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_giver_name().valid && get_Form_giver_name().touched"
              class="form-text text-muted MyErrorRedColor">نام فرستنده را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> سمت فرستنده </label>
            <input formControlName="giver_semat" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_giver_semat().valid && get_Form_giver_semat().touched"
              class="form-text text-muted MyErrorRedColor">سمت فرستنده را وارد نمائید.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> بازگشت به نامه شماره </label>
            <input formControlName="bazgashtBeNamehShomareh" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_bazgashtBeNamehShomareh().valid && get_Form_bazgashtBeNamehShomareh().touched"
              class="form-text text-muted MyErrorRedColor">بازگشت به نامه شماره را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-6" *ngIf="Letter_Form_Id==0 || !Letter_Form_Id">
            <label for="exampleInputEmail1"> بازگشت به نامه با تاریخ </label>
            <input formControlName="bazgashtBeNamehTarikh" type="text" class="form-control"
              #datepickerbazgashtBeNamehTarikh placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
              [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerbazgashtBeNamehTarikh"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-6" *ngIf="Letter_Form_Id>0">
            <label for="exampleInputEmail1"> بازگشت به نامه با تاریخ </label>
            <input formControlName="bazgashtBeNamehTarikh" disabled type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>
        </div>


      </form>



      <br />
      <hr />
      <br />

      <h5> تجهیزات </h5>

      <br />
      <br />
      <form *ngIf="canEditMainForm" [formGroup]="DeviceForm" (submit)="DeviceForm_Submit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)"
                class="btn btn-warning left"> انتخاب دستگاه (نام لاتین) <i class="fa fa-cc-amex"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Device_Record.title}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> عنوان فارسی </label>
            <select class="custom-select" formControlName="device_id">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Devicepersian" [value]="item.id">{{item.dsc}}</option>
            </select>
          </div>


        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> محل کالیبراسیون </label>
            <select class="custom-select" formControlName="location">
              <option value="0">انتخاب کنید</option>
              <option value="1">محل مشتری</option>
              <option value="2">آزمایشگاه بهینه</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تعداد</label>
            <input formControlName="tedad" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_DeviceForm_tedad().valid && get_DeviceForm_tedad().touched"
              class="form-text text-muted MyErrorRedColor">تعداد را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> مدت انقضاء </label>
            <select formControlName="Expiration" class="custom-select">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of Data_List_Expiration" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>


        <div class="row" *ngIf="Data_Seleted_Device_Record.title">
          <br />
          <div class="table-responsive">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #39409b; color: white;">
                <tr>
                  <th>#</th>
                  <th>ملاحظه</th>
                  <th>امکانات</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of DataList_Tariff">
                  <td>{{DataList_Tariff.indexOf(item)+1}}</td>
                  <td style="text-align: right;">{{item.dsc}}</td>

                  <td>
                    <label *ngIf="selected_Tariff_Record.id!=item.id" for="exampleInputEmail1"><button type="button"
                        (click)="set_Selected_Tariff(item)" class="btn btn-danger left"> انتخاب </button> </label>
                    <p *ngIf="selected_Tariff_Record.id==item.id" style="color: red;">ملاحظه انتخاب شد</p>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>



        <div class="row">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> توضیحات </label>
            <textarea type="text" placeholder="اینجا تایپ کنید ..." formControlName="dsc"
              class="form-control"></textarea>
          </div>

        </div>

        <button type="submit" [disabled]="!DeviceForm.valid" class="btn btn-success" style="margin-left: 5px;"><i
            class="fa  fa-plus-circle"></i> افزودن تجهیز </button>
      </form>


      <br />
      <br />

      <div class="table-responsive" *ngIf="DeviceFormList.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>دستگاه لاتین</th>
              <th>دستگاه فارسی</th>
              <th>محل کالیبراسیون</th>
              <th>مدت انقضاء</th>
              <th>تعداد</th>
              <th>ملاحظات</th>
              <th>توضیحات</th>
              <th>کاربر</th>
              <th>تاریخ</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DeviceFormList">
              <td>{{DeviceFormList.indexOf(item)+1}}</td>
              <td>{{item.device_name_en}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.location_name}}</td>
              <td>{{item.expiration_title}}</td>
              <td>{{item.tedad}}</td>
              <td>{{item.price_dsc}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.username}}</td>
              <td>{{item.persianDate}}</td>
              <td *ngIf="canEditMainForm">
                <div *ngIf="!item.del" class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;"
                        (click)="DeleteDeviceFormList_Modal(templateRemoveDevice,DeviceFormList.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>
                </div>
                <p *ngIf="item.del">حذف شده است</p>
              </td>
              <td *ngIf="!canEditMainForm">
                <p *ngIf="item.del">حذف شده است</p>
              </td>
            </tr>

          </tbody>
        </table>
      </div>

      <br />
      <hr />
      <br />


      <div *ngIf="canEditMainForm" class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            فایل/های ضمیمه
            <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
            class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>

      <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
        class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>

      <br />

      <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>فایل</th>

              <th *ngIf="canEditMainForm">امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of UploadImageSrc_List">

              <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
              <td>

                <a target="_blank" *ngIf="item.title.includes('.pdf')" href="{{BaseUrl}}File/Letter/{{item.title}}"
                  class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>


                <img *ngIf="!item.title.includes('.pdf')" (click)="openModal(templateImage,item.title)"
                  style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Letter/{{item.title}}" />
              </td>
              <td *ngIf="canEditMainForm">
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;"
                        (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-remove"></i> حذف </a>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>


    </div>


    <br />
    <br />

    <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="ReadHistory_Letter()" type="button"
      class="btn btn-warning" style="margin-left: 5px;"> <i class="fa fa-file-text"></i> جزئیات نامه </button>
    <ng-container *ngFor="let item of Data_List_Order">

      <button *ngIf="item.submit && !InProccessing" [disabled]="!AddNewLetter.valid" type="button"
        (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-left: 5px;"> <i
          [class]="item.icon"></i> {{item.title}} </button>

      <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
        (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-left: 5px;"> <i
          [class]="item.icon"></i> {{item.title}} </button>


    </ng-container>
    <img *ngIf="OpenOrderDialog_Loading" src="assets/Loading.gif" style="width: 25px;" />


    <br />
    <br />



  </div>



</div>


<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">جزئیات نامه '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">تاریخچه ارجاع</a>
            </li>

          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button" (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>حدف آخرین ارجاع</button>
        </div>

      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>
  </div>

</div>


<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه ها </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> نام دستگاه (نام لاتین) </label>
          <input type="text" class="form-control" (keyup)="ReadData_Device_KeySearch()"
            [(ngModel)]="Search_Name_Device_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,Selected_Order_Operation)"> ارسال و ثبت </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> درخواست کالیبراسیون </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>درخواست کالیبراسیون با شماره <b>'{{Letter_Form_Code}}'</b> با موفقیت ثبت شد </p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateRemoveDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید حذف دستگاه '{{DeleteDeviceFormList_Record.device_name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteDeviceFormList.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteDeviceFormList()"> حذف دستگاه <i
        class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeleteDeviceFormList.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>
